import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import ShortVideos from "@/pages/short-videos/page";
import MovieDetail from "@/pages/detail/movie/page";
import ShortVideoDetail from "@/pages/detail/short-video/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/movies",
    element: <Movies />,
  },
  {
    path: "/short-videos",
    element: <ShortVideos />,
  },
  {
    path: "/detail/movie/:id",
    element: <MovieDetail />,
  },
  {
    path: "/detail/short-video/:id",
    element: <ShortVideoDetail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;